module.exports = __webpack_public_path__ + "static/media/SCR-C-054.c08e3da2.mp3";